import { Col, DatePicker, Form, Input, Row } from "antd";
import Flex from "components/shared-components/Flex";
import React, { useLayoutEffect } from "react";
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { useState } from "react";
import moment from "moment";
import { useEffect } from "react";


const EducationAddFields = ({ field, remove, form, index, highEdu, showDegreeForm }) => {

  const [joiningYear, setJoiningYear] = useState(null)
  const [passoutYear, setPassoutYear] = useState(null)
  const [result, setResult] = useState()

  useEffect(() => {
    if(form.getFieldValue('education')) {
      setResult(form.getFieldsValue().education[index] ? form.getFieldsValue().education[index].percentage : '')
      setJoiningYear(form.getFieldsValue().education[index] ? form.getFieldsValue().education[index].joiningDate : null)
      setPassoutYear(form.getFieldsValue().education[index] ? form.getFieldsValue().education[index].passoutDate : null)
    }
  }, [form, index, highEdu])
  

  return (
    <div>
      <Flex justifyContent="end">
        <MinusCircleOutlined
          style={{ fontSize: "20px", color: "red" }}
          className="dynamic-delete-button"
          onClick={() => {
            remove(field.name);
          }}
        />
      </Flex>

      <Row key={field.key} gutter={8}>
        {
          showDegreeForm === 'school' &&
          <Col md={8} span={24}>
            <Form.Item
              {...field}
              name={[field.name, "schoolName"]}
              label="School / College Name"
              validateTrigger={["onChange", "onBlur"]}
              rules={[
                {
                  required: true,
                  whitespace: true,
                },
                {
                  pattern: "^([^0-9]*)$",
                  message: "School or college name should only be alphabetical characters",
                },
              ]}
            >
              <Input placeholder="School / College Name" />
            </Form.Item>
          </Col>
        }
        {
          showDegreeForm === 'degree' &&
          <Col md={8} span={24}>
            <Form.Item
              {...field}
              name={[field.name, "degree"]}
              label="Degree"
              validateTrigger={["onChange", "onBlur"]}
              rules={[
                {
                  required: true,
                  whitespace: true,
                },
                {
                  pattern: "^([^0-9]*)$",
                  message: "Degree should only be alphabetical characters",
                },
              ]}
            >
              <Input placeholder="Degree" />
            </Form.Item>
          </Col>
        }
        {
          showDegreeForm === 'degree' &&
          <Col md={8} span={24}>
            <Form.Item
              {...field}
              name={[field.name, "branch"]}
              label="Branch"
              validateTrigger={["onChange", "onBlur"]}
              rules={[
                {
                  required: true,
                  whitespace: true,
                },
                {
                  pattern: "^([^0-9]*)$",
                  message: "Branch should only be alphabetical characters",
                },
              ]}
            >
              <Input placeholder="Branch" />
            </Form.Item>
          </Col>
        }
        <Col md={8} span={24}>
          <Form.Item
            {...field}
            name={[field.name, "university"]}
            label="University / Board"
            validateTrigger={["onChange", "onBlur"]}
            rules={[
              {
                required: true,
                whitespace: true,
              },
              {
                pattern: "^([^0-9]*)$",
                message:
                  "University/Board should only be alphabetical characters",
              },
            ]}
          >
            <Input placeholder="University / Board" />
          </Form.Item>
        </Col>
        <Col md={8} span={24}>
          <Form.Item
            {...field}
            name={[field.name, "joiningDate"]}
            label="Joining Year"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <DatePicker
              className="w-100"
              placeholder="Joining Year"
              picker="month"
              format="MMM-YYYY"
              disabledDate={(current) => {
                let customDate = moment().format("MMM-YYYY");
                return current && current > moment(customDate, "MMM-YYYY");
              }} 
              onChange={(e) => setJoiningYear(e)}
            />
          </Form.Item>
        </Col>
        <Col md={8} span={24}>
          <Form.Item
            {...field}
            name={[field.name, "passoutDate"]}
            label="Passout Year"
            rules={[
              {
                required: true,
              },
              () => ({
                validator(rule, value) {
                    if (moment(joiningYear).diff(moment(value)) < 0) {
                        return Promise.resolve();
                    }
                    return Promise.reject("Passout year must be greater than joining year")
                },
            }),
            ]}
          >
            <DatePicker
              className="w-100"
              placeholder="Passout Year"
              picker="month"
              format="MMM-YYYY"
              disabledDate={(current) => {
                let customDate = moment().format("MMM-YYYY");
                return current && current > moment(customDate, "MMM-YYYY").add(1, 'month');
              }}
              onChange={e => setPassoutYear(e)}
            />
          </Form.Item>
        </Col>
        <Col md={8} span={24}>
          <Form.Item
            {...field}
            name={[field.name, "percentage"]}
            label="Percentage / CGPA"
            validateTrigger={["onChange", "onBlur"]}
            rules={[
              {
                required: true,
              },
              () => ({
                validator(rule, value) {
                    const reg = /^\d*\.?\d*$/;
                    if (reg.test(value)) {
                        return Promise.resolve();
                    }
                    return Promise.reject("Percentage / CGPA should be a number")
                },
              }),
            ]}
          >
            <Input
              placeholder="Percentage / CGPA"
              onChange={e => setResult(e.target.value)}
              addonAfter={
                result 
                ?
                parseFloat(result) > 10 ? (<span>%</span>) : (<span>CGPA</span>)
                :
                <span>-</span>
              }
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default EducationAddFields;
